import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from './Button';

var FlatButton = function FlatButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    variant: "flat"
  }));
};

FlatButton.displayName = 'FlatButton';
export default FlatButton;